import { createApiClient } from '@oneblinktech-org/helios-base';
import { getCookie } from '../helpers/globals';

const apiUrl = process.env.REACT_APP_API_URL;
const { get } = createApiClient({ apiUrl });

export function getPermissions() {
    const token = localStorage.getItem('h-access_token')
    const orgId = getCookie('active_organization_id')

    return get('/me/permissions', {
        Authorization: `Bearer ${token}`
    }).then(result => {
        const orgPermission = result.find(
            ({ organization_id }) => organization_id === Number(orgId)
        );

        return {
            permissions: orgPermission?.permissions ?? []
        };       
    }).catch(e => {
        throw e;
    });
}